module.exports = __webpack_public_path__ + "static/media/PechugasdePolloconAderezodeMayonesa.fe279833.webp";